import React, { useState, useEffect } from 'react';
import { AccountInfoPage } from '@projectK/modules/MyProfile';
import { Box } from '@mui/material';
import jwtAxios from '@projectK/services/auth/JWT';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import SettingsPage from '../SettingsPage';

const AccountInfo = () => {
  const { user } = useAuthUser();
  const [settings, setBasicSettings] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await jwtAxios.get(`/users/${user.id}`);
      setBasicSettings(response.data);
    } catch (error) {
      // Handle error
      console.error('Error fetching appearance settings:', error);
    }
  };
  return (
    <Box>
      {settings ? (
          <AccountInfoPage settings={settings} fetchData={fetchData} SettingsPage={SettingsPage} />
        
      ) : (
        <p>Loading basic settings...</p>
      )}
    </Box>
  );
};

export default AccountInfo;
